import type { FaireProductEntity } from "../../entity_types/product";

export const p_hychvz68ep: FaireProductEntity = {
  token: "p_hychvz68ep",
  type: "product",
  name: "Step Inside the World of Elizabeth Bennett and Mr. Darcy: A Classic Coloring Book",
  brandToken: "b_bomzcs63",
  brandName: "Hachette Book Group",
  imageUrl: "https://cdn.faire.com/fastly/b724dce6e01b8289b60176eab26d37a0ee7fe0bb820750a8a0e0d2f01c2db947.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2607bc453a56445ec643bdb691533720ee106e5931234853bc26f0127c15a291.jpeg",
    "https://cdn.faire.com/fastly/87bce7c60d408f49c35d0be68ffd93fcfc3cc817cb379d3f930696def395520d.jpeg",
    "https://cdn.faire.com/fastly/b12ff6c2d51013678fc2c36a971630ed84d93f6f6bffac707109b2dfd2ca3edd.jpeg",
    "https://cdn.faire.com/fastly/814dfe48d7b81294c80e52462aa0a4e1f29d4940bb3e8c19c9a30a43df35137b.jpeg",
    "https://cdn.faire.com/fastly/72cafc3f7526ddb85de3270ab5e74f5b4ae673856389c369a8dae0b106b8bab1.jpeg",
    "https://cdn.faire.com/fastly/b4e79de1df39bfd4bfdc63db9fcd1676da8d07e80ab235b416de189c8cea10f5.jpeg",
    "https://cdn.faire.com/fastly/0343f7045ef7c596c4a3c02592f8aa9d84eeb6531cc3d642699589c24ddc95ce.jpeg"
  ],
  priceDollars: 7.5,
  description: "Step inside the rich, literary world of Elizabeth Bennett and Mr. Darcy with this elegant and detailed coloring book. It brings the beloved classic to life through intricate pages that capture the romance and charm of Regency England. Featuring over 40 high-quality illustrations sourced from classic artwork of the original text, this beautiful wibalin paperback coloring book transforms the classic novel into a creative experience.",
  tags: [],
  msrpDollars: 14.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:07:11.742Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
